<template>
  <div class="settings-meetings" style="overflow: auto">
    <!-- Using overflow for sortable : Perfect scrollbar prevents scrolling while dragging -->
    <ExpandableSettingsItem :title="$t('message.MEETINGS_PLANNINGS')" class="settings-meetings__plannings">
      <div>
        <div class="generic-background">
          <MeetingPlanningItem v-for="planning in meetingPlannings" :key="planning.id" :meeting-planning="planning" />
          <button
            class="generic-border generic-border--text-btn generic-border--white v-centerer mt10"
            @click="addPlanning"
          >
            <div class="generic-border__left">
              <Icon class="generic-border__left-blue-icon">{{ addExtraBold }}</Icon>
              <span>{{ $t("message.ADD_PLANNING") }}</span>
            </div>
            <Icon class="generic-border__right-arrow">{{ arrowDownLine }}</Icon>
          </button>

          <div class="field-hint settings-meetings__plannings__hint">
            {{ $t('message.SETTINGS_MEETINGS_SAVED_AUTOMATICALLY') }}
          </div>
        </div>
      </div>
    </ExpandableSettingsItem>
    <ExpandableSettingsItem v-if="currentTeam" :title="$t('message.MEETINGS_ADD_INFO')">
      <div>
        <IntCheckbox
          v-if="currentTeam.accessGW"
          :value="currentTeam.hideInfoGW"
          :title="$t('message.HIDE_INFO_GW')"
          @input="saveParams('hideInfoGW', $event)"
        />
        <br>
        <IntCheckbox
          :value="currentTeam.hideInfoSuggestions"
          :title="$t('message.HIDE_INFO_SUGGESTIONS')"
          @input="saveParams('hideInfoSuggestions', $event)"
        />
      </div>
    </ExpandableSettingsItem>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
// Import components
import ExpandableSettingsItem from '@/components/expandable-settings-item.vue';
import Icon from '@/components/icon.vue';
import IntCheckbox from '@/components/int-checkbox.vue';
import MeetingPlanningItem from '@/components/meeting-planning-item.vue';
// Import utils
import { GET_TEAMS } from '@/store/mutation-types';
import { FETCH_TEAMS, SET_TEAM_PARAM } from '@/store/action-types';
import { FETCH_PLANNINGS, SET_PLANNING } from '@/store/modules/meeting/action-types';
import { GET_PLANNINGS } from '@/store/modules/meeting/mutation-types';
import { REPEAT_TYPE, DEFAULT_REPEAT_DATA } from '@/utils/meeting-utils';
import { addExtraBold, arrowDownLine } from '@/assets/icons';
import { ShizenGlobalEvent, globalEventDispatcher } from '@/utils/event-dispatcher/global';

const { mapState: meetingMapState } = createNamespacedHelpers('meeting');


export default {

  name: 'SettingsMeetings',

  components: {
    ExpandableSettingsItem,
    Icon,
    IntCheckbox,
    MeetingPlanningItem,
  },

  props: {
    admin: Boolean,
  },

  data() {
    return {
      addExtraBold,
      arrowDownLine,
      hideInfoGW: 0,
      hideInfoSuggestions: 0,
      meetingPlannings: [],
      planningHasBeenCreated: false,
      // Properties used by other components. See src/views/readme.md
      pageTitle: this.$t('message.SETTINGS_MEETINGS'),
    };
  },

  computed: {
    thisTeamIds() {
      let ids = [];
      this.teamsData.forEach((team) => {
        if (team.id === this.currentTeam.id) {
          ids = team.users.map(user => Number(user.id));
        }
      });
      return ids;
    },
    ...mapState({
      teamsLoading: state => state[GET_TEAMS.loadingKey],
      teamsData: state => state[GET_TEAMS.stateKey] || [],
    }),
    ...meetingMapState({
      plannings: state => state[GET_PLANNINGS.stateKey] || [],
      planningsLoading: state => state[GET_PLANNINGS.loadingKey],
    }),
  },

  watch: {
    plannings: {
      deep: true,
      handler(nv) {
        this.meetingPlannings = cloneDeep(nv);
      },
    },
  },

  beforeRouteLeave(to, from, next) {
    next();
    if (this.planningHasBeenCreated) {
      globalEventDispatcher.dispatch(
        ShizenGlobalEvent.LEAVING_MEETING_SETTINGS_AFTER_CREATION,
      );
    }
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    /**
     * Fetch data from the server needed for the page initialization
     */
    fetchData() {
      if (!this.$route.meta.requireConfig) {
        this.$store.dispatch(FETCH_TEAMS);
        this.$http.get('/server/team/parameters').then(({ data }) => {
          this.hideInfoGW = data.hideInfoGW;
          this.hideInfoSuggestions = data.hideInfoSuggestions;
        });
        if (!this.planningsLoading) {
          this.$store.dispatch(`meeting/${FETCH_PLANNINGS}`);
        }
      }
    },
    saveParams(param, val) {
      this.$store.dispatch(SET_TEAM_PARAM, { [param]: val });
    },
    /** Create a new meeting planning */
    addPlanning() {
      this.planningHasBeenCreated = true;
      const params = {
        id: 0,
        repeatType: REPEAT_TYPE.daily,
        repeatData: DEFAULT_REPEAT_DATA[0],
        participantIds: this.thisTeamIds,
      };
      this.$store.dispatch(`meeting/${SET_PLANNING}`, params);
    },
  },
};
</script>

<style lang="scss">
.settings-meetings {
  .add-button.add-planning {
    margin-top: 1em;
  }
  .meeting-steps {
    > .add-button {
      margin: 1em 0px 1em 0px;
      padding: 0.3em 0.2em;
    }
  }

  &__plannings {
    &__hint {
      padding: 1em;
    }
  }
}
</style>
